import { Injectable } from "@angular/core";
import { SharedService } from "./shared.service";
import { HttpClient } from "@angular/common/http";
import { UserMaster } from "../models/Masters/userMaster";
import { Router } from "@angular/router";
import { RolePageResponse } from "../models/Masters/roleMaster";
import { tap } from "rxjs/operators";
import { ScanFilterStateService } from "./scan-filter-state.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  url;
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private httpClient: HttpClient,
    private scanFilterState: ScanFilterStateService
  ) {
    this.url = sharedService.baseURL;
  }
  checkUser(login: any): any {
    return this.httpClient.post<any>(`${this.url}/api/Login`, login);
  }
  user(): UserMaster {
    if (localStorage.user) {
      const userDetails: UserMaster = JSON.parse(localStorage.user);
      return userDetails;
    }
    return null;
  }
  getToken() {
    let token = localStorage.getItem("token");
    token = token ? token : "";
    return token;
  }
  signOut() {
    localStorage.clear(); // or remove token only
    sessionStorage.clear();
    this.scanFilterState.reset();
    this.router.navigateByUrl("/login");
  }
  isLogged(): boolean {
    const token = this.getToken();
    if (token) {
      if (window.location.pathname === "/pa") {
        return false;
      }
      return true;
    }
    // this.router.navigate(["/login"]);
    return false;
  }
  getMenu(menu) {
    return this.httpClient.post<any>(
      `${this.url}/api/RoleMaster/PageGetAllByUser`,
      menu
    );
  }
  refreshToken() {
    const rToken = localStorage.getItem("refreshToken");
    const userDetails: UserMaster = JSON.parse(localStorage.user);
    const uId = userDetails.usrId;
    return this.httpClient
      .get<any>(`${this.url}/api/refreshtoken/${rToken}/${uId}`)
      .pipe(
        tap((tokens: any) => {
          this.storeTokens(tokens);
        })
      );
  }
  private storeTokens(tokens: any) {
    localStorage.token = tokens.token;
    localStorage.refreshToken = tokens.refreshToken;
  }
  forgotPassword(emailId: any) {
    return this.httpClient.get<any>(
      `${this.url}/api/ForgotPassword?emailId=${emailId}`
    );
  } 
  checkRequestNo(reqNo: any) {
    return this.httpClient.get<any>(
      `${this.url}/api/CheckRequestNo?reqNo=${reqNo}`
    );
  }
  resetPassword(form: any) {
    return this.httpClient.post<any>(`${this.url}/api/ResetPassword`, form);
  }
}
